import AppointmentInt from "../../domain/appointments/AppointmentInt";

export interface AppointmentProps {
  appointment: AppointmentInt;
}

export const AppointmentsListItem = ({ appointment }: AppointmentProps) => {
  return (
    <tbody>
      <tr>
        <td
          data-title="Datum: "
          style={{ backgroundColor: "#ffffff70", fontSize: "1.2rem" }}
        >
          <span>
            {appointment.startdate} {appointment.starttime}
          </span>
          <br />
          <span>-</span>
          <br />
          <span>
            {appointment.enddate} {appointment.endtime}
          </span>
          <br />
        </td>
        <td
          data-title="Was: "
          style={{ 
            backgroundColor: "#ffffff70", 
            fontSize: "1.2rem",
            color: appointment.highlight ? "red" : "inherit",
            fontWeight: appointment.highlight ? "bold" : "normal", 
          }}
        >
          {appointment.what}
        </td>
        <td
          data-title="Wer:"
          style={{ backgroundColor: "#ffffff70", fontSize: "1.2rem" }}
        >
          {appointment.who}
        </td>
        <td
          data-title="Wo:"
          style={{ backgroundColor: "#ffffff70", fontSize: "1.2rem" }}
        >
          <span>{appointment.street}</span>
          <br />
          <span>
            {appointment.plz} {appointment.town}
          </span>
          <br />
          <span>{appointment.location}</span>
          <p />
        </td>
        <td
          data-title="Kontakt: "
          style={{ backgroundColor: "#ffffff70", fontSize: "1.2rem" }}
        >
          <p>{appointment.telefon}</p>
          <p>{appointment.email}</p>
        </td>
      </tr>
    </tbody>
  );
};
